import { api } from "../../api";

export default async function forgotPassword(email: string) {
  try {
    const { data, status } = await api.post("/auth/password/forgot", {
      email,
    });

    if (status === 200) {
      return data;
    }

    return null;
  } catch (err) {
    return null;
  }
}
